import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.NewRequestPopup.WorkflowsList', {
    description: 'Please open the "Approval workflows" page in your Organisation and add yourself as a Requester.',
    organisations: 'Organisations:',
    buttonText: 'Go to workflow',
});
